import apiService from '@/services/api.service'
import store from '@/store'

export default {



    async getHotels() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'reports/getHotelsForFilter',
                method: 'get',
                locale: lang
            }).then(response => {
                if (response.data.data) {
                    resolve(response.data.data);
                } else {
                    reject('empty hotels!');
                }
            }).catch((error) => {
                reject(error);
            });
        });
    },

    async getRegions() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'reports/getRegionsForFilter',
                method: 'get',
                locale: lang
            }).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async getStopsalesReportForFilter(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'reports/getStopsalesReportForFilter',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty results!')
                }
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async getStopSalesReport(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'reports/getStopSalesReport',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                resolve(response);
            }).catch((error) => {
                reject(error)
            })
        })
    }



}
